<template>
    <div class="normal-box">
        <el-row class="normal-box-bg">
            <el-row class="normal-box-title">
                <h1>公费师范生<br>填报服务</h1>
                <h2>两免一补、保证入编入岗</h2>
            </el-row>
            <el-row class="normal-box-student normal-box-common">
                <h3>
                    什么是公费师范生
                </h3>
                <div class="normal-box-you-title">WHAT IS A NORMAL STUDENT AT PUBLIC EXPENSE</div>
                <p>
                    师范生公费教育政策是指由中央财政或者负责安排师范类学生在校期间的学费、住宿费，并发放生活补贴，但学生四年毕业以后必须回到生源省份从事至少六年教育工作。
                </p>
            </el-row>
        </el-row>
        <el-row class="normal-box-you normal-box-common normal-box-common1">
            <h3>优惠政策</h3>
            <div class="normal-box-you-title">FAVOURED POLICY</div>
            <el-row class="normal-box-you-infor">
                <el-row class="normal-box-you-list" type="flex" justify="space-between">
                    <el-col v-for="(item,index) in youList" :key="index">
                        <img :src="item.src">
                        <h4>{{item.title}}</h4>
                        <p>{{item.desc}}</p>
                    </el-col>
                </el-row>
            </el-row>
        </el-row>
        <el-row class="normal-box-xue normal-box-common">
            <h3>
                哪些考生适合
            </h3>
            <div class="normal-box-you-title">WHICH CANDIDATES ARE SUITABLE</div>
            <el-row class="normal-box-xue-list" type="flex" justify="space-between">
                    <el-col v-for="(item,index) in xueList" :key="index">
                        <img :src="item.src">
                        <h4>{{item.title}}</h4>
                        <p>{{item.desc}}</p>
                    </el-col>
                </el-row>
        </el-row>
        <el-row class="normal-box-tiao normal-box-common normal-box-common1">
            <h3>
                报考条件    
            </h3>
            <div class="normal-box-you-title">REGISTRATION CONDITIONS</div>
            <el-row class="normal-box-tiao-list">
                    <el-row>
                        <el-col :span="1">1</el-col>
                        <el-col :span="23">参加普通高校招生全国统一考试，达到部属师大在河南的录取分数线；</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="1">2</el-col>
                        <el-col :span="23">符合《教育部普通高校招生工作规定》，热爱教育事业，毕业后愿意长期从教；</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="1">3</el-col>
                        <el-col :span="23">身体健康，符合《普通高等学校招生体检工作指导意见》的有关规定。</el-col>
                    </el-row>
                </el-row>
        </el-row>
        <el-row class="normal-box-nan normal-box-common normal-box-common1">
            <h3>填报难度</h3>
            <div class="normal-box-you-title">REPORTING DIFFICULTY</div>
            <img src="../../assets/images/normal-nan.png">
            <!-- <el-row class="normal-box-nan-item" style="margin-top: 48px">
                院校梯度需合理搭配
            </el-row> -->
            <el-row style="margin-top: 64px;">
                <el-row class="normal-box-nan-list">
                    <el-col class="normal-box-nan-item" style="margin-right: 154px">
                        不清楚公费师范生具体招生政策
                    </el-col>
                    <el-col class="normal-box-nan-item" style="margin-left: 154px">
                        不知道该选什么专业
                    </el-col>
                </el-row>
                <el-row class="normal-box-nan-list">
                    <el-col class="normal-box-nan-item" style="margin-right: 154px">
                        不知道如何填报
                    </el-col>
                    <el-col class="normal-box-nan-item" style="margin-left: 154px">
                        不知道该做什么样的准备
                    </el-col>
                </el-row>
            </el-row>
        </el-row>
        <el-row class="normal-box-step normal-box-common">
            <h3>服务流程</h3>
            <div class="normal-box-you-title">SERVICE PROCESS</div>
            <el-row class="normal-box-step-list" type="flex" justify="space-between">
                <el-col class="normal-box-step-item">
                    <div class="normal-box-step-title">
                        <div>1</div>
                        <p>根据考生职业测评结果、报考意向，帮助学生确定适合报考学校和专业</p>
                    </div>
                    <span class="normal-box-step-item-line"></span>
                    <span class="normal-box-step-item-arrow"></span>
                </el-col>
                <el-col class="normal-box-step-item">
                    <div class="normal-box-step-title">
                        <div>2</div>
                        <p>一对一讲解服务，引导考生及家长了解公费师范生的招生、录取特点和具体要求</p>
                    </div>
                    <span class="normal-box-step-item-line"></span>
                    <span class="normal-box-step-item-arrow"></span>
                </el-col>
                <el-col class="normal-box-step-item">
                    <div class="normal-box-step-title">
                        <div>3</div>
                        <p>高考前根据考生具体情况制作高考志愿填报预案</p>
                    </div>
                    <span class="normal-box-step-item-line"></span>
                    <span class="normal-box-step-item-arrow"></span>
                </el-col>
                <el-col class="normal-box-step-item">
                    <div class="normal-box-step-title">
                        <div>4</div>
                        <p>出分后根据考生具体分数，对预案进行调整，做出高考志愿填报最终方案，并指导考生进行相关填报工作</p>
                    </div>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="normal-box-service normal-box-common normal-box-common1">
            <h3>服务优势</h3>
            <div class="normal-box-you-title" style="color: #f1f2f2;">REGISTRATION CONDITIONS</div>
            <el-row class="normal-box-service-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in serviceList" :key="index">
                    <img :src="item.src">
                    <h4>{{item.title}}</h4>
                    <div>{{item.desc}}</div>
                </el-col>
            </el-row>
            <el-row class="normal-box-infor normal-box-order">
                <img src="../../assets/images/channel-order.png" alt="">
                <div>
                    <span class="normal-box-order-title">预约专家 免费咨询</span>
                    <span class="normal-box-order-desc">留下联系方式，立即与专家一对一</span>
                </div>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            youList: [
                {src:require('../../assets/images/normal-you1.png'),title:'“两免一补”免除学费、住宿费',desc:'由中央财政承担其在校期间学费、住宿费并给予生活费补助的培养管理制度。'},
                {src:require('../../assets/images/normal-you2.png'),title:'“两免一补”补助生活费',desc:'国家根据经济发展水平和财力状况，对公费师范生的生活费补助标准进行动态调整。'},
                {src:require('../../assets/images/normal-you3.png'),title:'保证入编入岗',desc:'实行公费师范生专项招聘，为每一位毕业的公费师范生落实任教学校并确保有编有岗。'},
                {src:require('../../assets/images/normal-you4.png'),title:'其他非义务性奖学金',desc:'优秀公费师范生可享受其他非义务性奖学金。'},
            ],
            xueList: [
                {src:require('../../assets/images/normal-xue1.png'),title:'综合成绩优秀',desc:'提前批公费师范全部是教育部直属重点211/985高校，录取分数相对较高。（地方公费师范生也属提前批填报）'},
                {src:require('../../assets/images/normal-xue2.png'),title:'愿意从事基础教育工作',desc:'公费师范毕业后要回到生源地从事基础教学和教学管理工作至少六年，如果没有长期打算从事中小学教育事业，不要贸然选择。'},
                {src:require('../../assets/images/normal-xue3.png'),title:'自制力强',desc:'公费师范生毕业后肯定要安排工作，导致不少学生在学校里不思进取，以混毕业证为目的。这种情况尤其在自制力差的学生身上体现的很明显，如果孩子自制力不强报公费师范，很容易就会在大学期间浑浑噩噩过四年。'},
            ],
            serviceList: [
                {src:require('../../assets/images/bus-service-icon1.png'),title:'团队优势',desc:'荔枝新高考顶级专家团队全程跟踪,一对一线上线下规划指导'},
                {src:require('../../assets/images/bus-service-icon2.png'),title:'流程优势',desc:'一站式服务、自我评估、目标定位、院校选择多重指导等'},
                {src:require('../../assets/images/bus-service-icon3.png'),title:'品牌保障',desc:'可靠的品牌支撑，实力、可信、靠谱'},
            ],
            formInline: {
                username: '',
                phone: '',
                type: '3'
            }
        };
    },

    mounted() {
        
    },

    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@font-face {
    font-family: 'Impact';
    src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$width: 1200px;
$margin: 0 auto;
$font-family: 'MicrosoftYaHei';
.normal-box-bg {
    background: url('../../assets/images/normal-bg.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    height: 825px;
    .normal-box-title {
        width: $width;
        margin: $margin;
        margin-top: 80px;
        padding-left: 16px;
    }
    h1 {
        font-size: 90px;
        font-family: $font-family;
        font-weight: 600;
        text-align: left;
        color: #ffffff;
        line-height: 120px;
        letter-spacing: 2px;
        margin: $margin;
        text-shadow: 0px 2px 4px 0px rgba(65,81,75,0.54); 
    }
    h2 {
        margin: 0;
        width: 390px;
        height: 70px;
        background: rgba(32,90,255,0.74);
        border-radius: 36px;
        margin-top: 32px;
        font-size: 28px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 70px;
        letter-spacing: 2px;
    }
    .normal-box-student {
        height: 319px;
        background: rgba(0,156,96,0.86);
        border-radius: 20px;
        box-shadow: 0px 6px 0px 0px #08905c, 0px 6px 0px 0px rgba(255,255,255,0.56) inset; 
        backdrop-filter: blur(3px);
        width: $width;
        margin-top: 84px!important;
        padding: 62px;
        box-sizing: border-box;
        position: absolute;
        z-index: 99;
        left: 50%;
        transform: translateX(-50%);
        p {
            font-size: 22px;
            font-weight: 400;
            color: #ffffff;
            line-height: 46px;
            margin-top: 54px;
        }
    }
}
.normal-box-you {
    height: 930px;
    h3 {
        color: #ffffff;
    }
    .normal-box-you-title {
        color: rgba(255,255,255,0.23);
        top: 25px;
    }
    .normal-box-you-infor {
        width: $width;
        margin: $margin;
        margin-top: 72px;
        position: relative;
        .normal-box-you-list {
            flex-wrap: wrap;
        }
        .el-col {
            width: 580px;
            height: 316px;
            background: #eff7f3;
            border: 1px solid #c5e9d9;
            border-radius: 20px;
            margin-bottom: 40px;
            padding: 32px;
            box-sizing: border-box;
            text-align: center;
        }
    }
    .normal-box-you-list {
        h4 {
            font-family: $font-family;
            margin: 0;
            padding: 0;
            margin-top: 24px;
            font-size: 30px;
            font-weight: 400;
            text-align: center;
            color: #353937;
            line-height: 42px;
        }
        p {
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: left;
            color: #606664;
            line-height: 36px;
        }
    }
}
.normal-box-common {
    position: relative;
    background: #ffffff;
    .normal-box-you-title {
        position: absolute;
        font-size: 28px;
        font-family:'Impact';
        font-weight: 700;
        text-align: center;
        color: #2ab582;
        left: 50%;
        transform: translateX(-50%);
        top: 86px;
    }
    h3 {
        font-weight: 700;
        font-size: 40px;
        letter-spacing: 6px;
        margin: 0 auto;
        padding: 0;
        text-align: center;
        font-family: $font-family;
        position: relative;
        z-index: 99;
        color: #ffffff;
    }
}
.normal-box-common1 {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        color: #15B174;
        line-height: 50px;
    }
    .normal-box-you-title {
        top: 90px;
        font-size: 32px;
        font-family: 'Impact';
        font-weight: 400;
        text-align: center;
        color: #f1f2f2;
        line-height: 39px;
        
    }
}
.normal-box-xue {
    height: 798px;
    background: url('../../assets/images/normal-student-xue.jpg') no-repeat center;
    background-size: cover;
    padding-top: 62px;
    .normal-box-xue-list {
        width: $width;
        margin: $margin;
        margin-top: 150px;
        .el-col {
            width: 372px;
            height: 461px;
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0px 10px 0px 0px #cfdbff inset; 
            text-align: center;
            padding: 32px;
            box-sizing: border-box;
            img {
                margin-top: -126px;
                border: 4px solid #205aff;
                border-radius: 50%;
                width: 174px;
                height: 174px;
            }
            h4 {
                font-family: $font-family;
                margin: 0;
                padding: 0;
                margin-top: 24px;
                font-size: 30px;
                font-weight: 400;
                text-align: center;
                color: #353937;
                line-height: 42px;
            }
            p {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: left;
                color: #606664;
                line-height: 36px;
            }
        }
    }
}
.normal-box-tiao {
    height: 568px;
    background: #ffffff;
    .normal-box-tiao-list {
        width: $width;
        margin: $margin;
        padding: 0 41px;
        margin-top: 64px;
        .el-row {
            height: 90px;
            background: #eff7f3;
            border-radius: 8px;
            padding: 25px 20px;
            box-sizing: border-box;
            line-height: 40px;
            margin-bottom: 24px;
            .el-col-1 {
                width: 40px;
                height: 40px;
                background: #1f6dda;
                border-radius: 8px;
                font-size: 24px;
                font-family: 'Impact';
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 40px;
            }
            .el-col-23 {
                font-size: 24px;
                font-family: $font-family;
                font-weight: 700;
                color: #2c3331;
                padding-left: 18px;
            }
        }
    }
}
.normal-box-nan {
    width: 100%;
    height: 642px;
    background: #f0f7f4;
    position: relative;
    .normal-box-you-title {
        color: #d1e1db;
    }
    img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 64px;
    }
    .normal-box-nan-item {
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(6px);
        color: #2c3331;
        font-size: 24px;
        font-weight: 400;
        margin: $margin;
        padding: 0 30px;
        text-align: center;
        line-height: 36px;
        width: 296px;
        height: 114px;
        background: #ffffff;
        border: 2px solid #009c5c;
        border-radius: 20px;
        box-shadow: 0px 0px 20px 0px rgba(0,156,92,0.11); 
    }
    .normal-box-nan-list {
        width: 900px;
        margin: $margin;
        margin-bottom: 164px;
    }
}
.normal-box-step {
    background: url('../../assets/images/normal-step.jpg') no-repeat;
    height: 560px;
    width: 100%;
    background-position: center;
    background-size: cover;
    position: relative;
    padding-top: 62px;
    .normal-box-step-list {
        width: $width;
        margin: $margin;
        margin-top: 110px;
        position: relative;
    }
    .normal-box-step-item {
        position: relative;
        width: 258px;
    }
    .normal-box-step-title {
        width: 258px;
        height: 265px;
        background: #ffffff;
        border-radius: 20px;
        box-shadow: 0px 10px 0px 0px #cfdbff inset;
        padding: 29px;
        box-sizing: border-box;
        div {
            width: 74px;
            height: 74px;
            background: #1f6dda;
            border-radius: 43px;
            font-size: 40px;
            font-family: 'Impact';
            font-weight: 400;
            text-align: center;
            color: #fff6e8;
            line-height: 74px;
            margin: 0 auto;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -40px;
        }
        p {
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            color: #66605e;
            line-height: 36px;
            margin-top: 24px;

        }
    }
    .normal-box-step-item-line {
        display: inline-block;
        width: 45px;
        border-top: 2px dashed #48be91;
        position: absolute;
        left: 258px;
        top: 50%;
        transform: translateY(-50%);
    }
    .normal-box-step-item-arrow {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-left: 16px solid #48be91;
        border-bottom: 8px solid transparent;
        position: absolute;
        left: 300px;
        top: 50%;
        transform: translateY(-50%);
    }
}
.normal-box-service {
    height: 1011px;
    background: url('../../assets/images/normal-fu.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    background-position: center;
    margin-bottom: -56px;
    .normal-box-service-list {
        width: $width;
        margin: $margin;
        margin-top: 142px;
        .el-col {
            padding: 32px 42px;
            box-sizing: border-box;
            text-align: center;
            width: 351px;
            height: 326px;
            background: #eff7f3;
            border: 1px solid #009c60;
            border-radius: 20px;
            box-shadow: 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
            backdrop-filter: blur(6px);
            img {
                margin-top: -100px;
            }
            h4 {
                font-size: 30px;
                font-family: $font-family;
                font-weight: 700;
                text-align: center;
                color: #2c3331;
                line-height: 36px;
                margin: 33px 0 24px 0;
            }
            div {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                color: #5e6663;
                line-height: 40px;
                text-align: left;
            }
        }
    }
}
.normal-box-order {
    @include gwidth;
    width: 1200px;
    height: 255px;
    background: linear-gradient(180deg,#ff9e4a, $common-color);
    border-radius: 20px;
    box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
    padding: 48px;
    margin-top: 90px;
    position: relative;
    margin-bottom: 28px;
    span {
        display: inline-block;
    }
    img {
        position: absolute;
        top:0;
        left: 0;
    }
    .normal-box-order-title {
        font-size: 36px;
        font-family: 'zihun443hao';
        color: #ffffff;
    }
    .normal-box-order-desc {
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
    }
}
</style>